import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_18 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_22 = {
  key: 0,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_23 = { class: "col p-0" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 1,
  class: "form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 2,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_31 = { class: "col p-0" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_34 = { class: "col p-0" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = {
  key: 3,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_37 = { class: "col p-0" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "form-group mb-2 col" }
const _hoisted_40 = { class: "col-auto p-0 text-end" }
const _hoisted_41 = { class: "col-sm-12" }
const _hoisted_42 = { class: "card card-body" }
const _hoisted_43 = { class: "overflow-auto" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "row mb-2" }
const _hoisted_46 = { class: "col-sm-12" }
const _hoisted_47 = { class: "row mt-2" }
const _hoisted_48 = {
  for: "type",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_49 = { class: "col-sm-8" }
const _hoisted_50 = { class: "row mt-2" }
const _hoisted_51 = {
  for: "amount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_52 = { class: "col-sm-8" }
const _hoisted_53 = { class: "row mt-2" }
const _hoisted_54 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_55 = { class: "col-sm-8" }
const _hoisted_56 = { class: "row mt-2" }
const _hoisted_57 = {
  for: "store",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_58 = { class: "col-sm-8" }
const _hoisted_59 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_60 = {
  for: "paymentOption",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_61 = { class: "col-sm-8" }
const _hoisted_62 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_63 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_64 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_65 = {
  for: "crossBorderCurrency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_66 = { class: "col-sm-8" }
const _hoisted_67 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_68 = {
  for: "paymentMethod",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_69 = { class: "col-sm-8" }
const _hoisted_70 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_71 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_72 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_73 = {
  for: "requisites",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_74 = { class: "col-sm-8" }
const _hoisted_75 = ["data-maska", "data-maska-tokens"]
const _hoisted_76 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_77 = {
  for: "holderName",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_78 = { class: "col-sm-8" }
const _hoisted_79 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_80 = {
  for: "startDeal",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_81 = { class: "col-sm-8 d-flex align-items-center" }
const _hoisted_82 = { class: "row mt-2" }
const _hoisted_83 = {
  for: "internalId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_84 = { class: "col-sm-8" }
const _hoisted_85 = { class: "row mt-2" }
const _hoisted_86 = {
  for: "userId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_87 = { class: "col-sm-8" }
const _hoisted_88 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_89 = { class: "text-capitalize-first" }
const _hoisted_90 = { class: "text-capitalize-first" }
const _hoisted_91 = { class: "text-capitalize-first" }
const _hoisted_92 = { class: "text-capitalize-first" }
const _hoisted_93 = { class: "text-capitalize-first" }
const _hoisted_94 = { class: "text-capitalize-first" }
const _hoisted_95 = { class: "text-capitalize-first" }
const _hoisted_96 = { class: "text-capitalize-first" }
const _hoisted_97 = { class: "text-capitalize-first" }
const _hoisted_98 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_99 = { class: "text-capitalize-first" }
const _hoisted_100 = { class: "text-end" }
const _hoisted_101 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_102 = ["title"]
const _hoisted_103 = { class: "text-secondary" }
const _hoisted_104 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_105 = { class: "text-secondary" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "text-end" }
const _hoisted_108 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_InvoiceDetails = _resolveComponent("InvoiceDetails")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: "ID",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.id) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.requestDTO.id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          onKeydown: _cache[1] || (_cache[1] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                          placeholder: _ctx.trans('labels.customer_id'),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.userId) = $event))
                        }, null, 40, _hoisted_13), [
                          [_vModelText, _ctx.requestDTO.userId]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_17)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_21)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  (_ctx.store.getters.isMerchant || _ctx.store.getters.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[5] || (_cache[5] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: _ctx.helper.trans('labels.from_sum'),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.fromSum) = $event))
                            }, null, 40, _hoisted_25), [
                              [_vModelText, _ctx.requestDTO.fromSum]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.store.getters.isMerchant || _ctx.store.getters.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              onKeydown: _cache[7] || (_cache[7] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                              placeholder: _ctx.helper.trans('labels.to_sum'),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.toSum) = $event))
                            }, null, 40, _hoisted_29), [
                              [_vModelText, _ctx.requestDTO.toSum]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.store.getters.isMerchant)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_Multiselect, {
                              id: "currencies",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.currencies,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                              options: _ctx.currencyList,
                              "custom-label": (opt) => `${opt}`,
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.trans('labels.currencies')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: Object.values(_ctx.InvoiceStatus),
                          "custom-label": (opt) => _ctx.trans(`invoice_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.trans('labels.statuses')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  (_ctx.currentStore === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_Multiselect, {
                              id: "store",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.storeIds,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestDTO.storeIds) = $event)),
                              options: _ctx.storeIds,
                              "custom-label": (opt) => _ctx.store.getters['merchantStores/get'](opt)?.name,
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.trans('labels.stores')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportInvoices && _ctx.exportInvoices(...args)), ["prevent"])),
                        class: "btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first"
                      }, [
                        _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.trans('button.export')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.applyFilters()), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.resetFilters()), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_b_modal, {
                    "dialog-class": "modal-xl",
                    title: "Details",
                    modelValue: _ctx.details !== null,
                    "body-class": "pt-0",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ($event === false && (_ctx.details = null)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InvoiceDetails, { invoice: _ctx.details }, null, 8, ["invoice"])
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.details = null)),
                        class: "btn btn-outline-dark btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.trans("button.close")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_b_modal, {
                    "dialog-class": "",
                    title: _ctx.trans('labels.invoice'),
                    modelValue: _ctx.invoiceCreateForm !== null,
                    "body-class": "pt-0",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ($event === false && (_ctx.invoiceCreateForm = null)))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.invoiceCreateForm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("form", null, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.trans("labels.type")), 1),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createVNode(_component_Multiselect, {
                                        id: "type",
                                        class: "",
                                        modelValue: _ctx.invoiceCreateForm.type,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.invoiceCreateForm.type) = $event)),
                                        options: [_ctx.Direction.PAY_IN, _ctx.Direction.PAY_OUT],
                                        "custom-label": (opt) => _ctx.trans(`direction.${opt}`),
                                        multiple: false,
                                        "select-label": "Select",
                                        placeholder: ""
                                      }, null, 8, ["modelValue", "options", "custom-label"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.trans("labels.amount")), 1),
                                    _createElementVNode("div", _hoisted_52, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.invoiceCreateForm.amount) = $event)),
                                        type: "text",
                                        class: "form-control",
                                        id: "amount"
                                      }, null, 512), [
                                        [_vModelText, _ctx.invoiceCreateForm.amount]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.trans("labels.currency")), 1),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createVNode(_component_Multiselect, {
                                        id: "currency",
                                        class: "",
                                        modelValue: _ctx.invoiceCreateForm.currency,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.invoiceCreateForm.currency) = $event)),
                                        options: _ctx.store.getters['currencyMethods/currencies'],
                                        "custom-label": (opt) => `${opt}`,
                                        multiple: false,
                                        "select-label": "Select",
                                        disabled: "",
                                        placeholder: ""
                                      }, null, 8, ["modelValue", "options", "custom-label"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.trans("labels.store")), 1),
                                    _createElementVNode("div", _hoisted_58, [
                                      _createVNode(_component_Multiselect, {
                                        id: "store",
                                        class: "",
                                        modelValue: _ctx.invoiceCreateForm.storeId,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.invoiceCreateForm.storeId) = $event)),
                                        options: _ctx.store.getters['merchantStores/ids'],
                                        "custom-label": (opt) => _ctx.store.getters['merchantStores/get'](opt)?.name,
                                        multiple: false,
                                        "select-label": "Select",
                                        disabled: "",
                                        placeholder: ""
                                      }, null, 8, ["modelValue", "options", "custom-label"])
                                    ])
                                  ]),
                                  ([_ctx.Direction.PAY_IN, _ctx.Direction.PAY_OUT].includes(_ctx.invoiceCreateForm.type))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.trans("labels.payment_options")), 1),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createVNode(_component_Multiselect, {
                                            id: "paymentOption",
                                            class: "",
                                            modelValue: _ctx.invoiceCreateForm.paymentOption,
                                            "onUpdate:modelValue": [
                                              _cache[21] || (_cache[21] = ($event: any) => ((_ctx.invoiceCreateForm.paymentOption) = $event)),
                                              _cache[22] || (_cache[22] = ($event: any) => (_ctx.invoiceCreateForm.paymentMethod = null))
                                            ],
                                            modelModifiers: { number: true },
                                            options: _ctx.store.getters['currencyMethods/options'](_ctx.invoiceCreateForm.currency),
                                            "custom-label": (opt) => _ctx.trans(`payment_options.${opt}`),
                                            multiple: false,
                                            "select-label": "Select",
                                            placeholder: ""
                                          }, {
                                            option: _withCtx((props) => [
                                              _createElementVNode("div", _hoisted_62, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                                              ])
                                            ]),
                                            singleLabel: _withCtx((props) => [
                                              _createElementVNode("div", _hoisted_63, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "options", "custom-label"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isCrossBorderCurrencyShown)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.trans("labels.crossBorderCurrency")), 1),
                                        _createElementVNode("div", _hoisted_66, [
                                          _createVNode(_component_Multiselect, {
                                            id: "crossBorderCurrency",
                                            class: "",
                                            modelValue: _ctx.invoiceCreateForm.crossBorderCurrency,
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.invoiceCreateForm.crossBorderCurrency) = $event)),
                                            options: _ctx.crossBorderCurrencies,
                                            "custom-label": (opt) => `${opt}`,
                                            multiple: false,
                                            "allow-empty": false,
                                            "select-label": "Select",
                                            placeholder: ""
                                          }, null, 8, ["modelValue", "options", "custom-label"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  ([_ctx.Direction.PAY_IN, _ctx.Direction.PAY_OUT].includes(_ctx.invoiceCreateForm.type))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                        _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.trans("labels.payment_method")), 1),
                                        _createElementVNode("div", _hoisted_69, [
                                          _createVNode(_component_Multiselect, {
                                            id: "method",
                                            class: "",
                                            modelValue: _ctx.invoiceCreateForm.paymentMethod,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.invoiceCreateForm.paymentMethod) = $event)),
                                            modelModifiers: { number: true },
                                            options: _ctx.store.getters['currencyMethods/methods'](_ctx.invoiceCreateForm.currency, _ctx.invoiceCreateForm.paymentOption),
                                            "custom-label": (opt) => _ctx.trans(`pay_methods.${opt}`),
                                            multiple: false,
                                            "select-label": "Select",
                                            placeholder: ""
                                          }, {
                                            option: _withCtx((props) => [
                                              _createElementVNode("div", _hoisted_70, [
                                                _createVNode(_component_PayMethodIcon, {
                                                  "icon-class": "icon",
                                                  method: props.option
                                                }, null, 8, ["method"]),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.trans('pay_methods.' + props.option)), 1)
                                              ])
                                            ]),
                                            singleLabel: _withCtx((props) => [
                                              _createElementVNode("div", _hoisted_71, [
                                                _createVNode(_component_PayMethodIcon, {
                                                  "icon-class": "icon",
                                                  method: props.option
                                                }, null, 8, ["method"]),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.trans('pay_methods.' + props.option)), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "options", "custom-label"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.invoiceCreateForm.type === _ctx.Direction.PAY_OUT)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.helper.trans("labels.requisites")), 1),
                                        _createElementVNode("div", _hoisted_74, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.invoiceCreateForm.requisites) = $event)),
                                            "data-maska": _ctx.requisitesMaskaOptions.pattern,
                                            "data-maska-tokens": _ctx.requisitesMaskaOptions.tokens,
                                            type: "text",
                                            class: "form-control",
                                            id: "requisites"
                                          }, null, 8, _hoisted_75), [
                                            [_vModelText, _ctx.invoiceCreateForm.requisites],
                                            [_directive_maska]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.invoiceCreateForm.type === _ctx.Direction.PAY_OUT)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                        _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.helper.trans("labels.holder_name")), 1),
                                        _createElementVNode("div", _hoisted_78, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.invoiceCreateForm.holder) = $event)),
                                            type: "text",
                                            class: "form-control",
                                            id: "holderName"
                                          }, null, 512), [
                                            [_vModelText, _ctx.invoiceCreateForm.holder]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.invoiceCreateForm.type === _ctx.Direction.PAY_IN)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                        _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.trans("labels.create_deal")), 1),
                                        _createElementVNode("div", _hoisted_81, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.invoiceCreateForm.startDeal) = $event)),
                                            id: "startDeal",
                                            class: "form-check-input",
                                            type: "checkbox"
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.invoiceCreateForm.startDeal]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.trans("labels.invoice_id")), 1),
                                    _createElementVNode("div", _hoisted_84, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.invoiceCreateForm.internalId) = $event)),
                                        type: "text",
                                        class: "form-control",
                                        id: "internalId"
                                      }, null, 512), [
                                        [_vModelText, _ctx.invoiceCreateForm.internalId]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.trans("labels.uid")), 1),
                                    _createElementVNode("div", _hoisted_87, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.invoiceCreateForm.userId) = $event)),
                                        type: "text",
                                        class: "form-control",
                                        id: "userId"
                                      }, null, 512), [
                                        [_vModelText, _ctx.invoiceCreateForm.userId]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.invoiceCreateForm = null)),
                        class: "btn btn-outline-dark btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.trans("button.cancel")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.createInvoice && _ctx.createInvoice(...args))),
                        class: "btn btn-outline-primary btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.trans("button.create")), 1)
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue"]),
                  _createElementVNode("table", _hoisted_88, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.trans("labels.id")), 1),
                        _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.trans("labels.type")), 1),
                        _createElementVNode("th", _hoisted_91, _toDisplayString(_ctx.trans("labels.payment_option")), 1),
                        _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.trans("labels.payment_method")), 1),
                        _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.trans("labels.date")), 1),
                        _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.trans("labels.store")), 1),
                        _createElementVNode("th", _hoisted_95, _toDisplayString(_ctx.trans("labels.uid")), 1),
                        _createElementVNode("th", _hoisted_96, _toDisplayString(_ctx.trans("labels.sum")), 1),
                        _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.trans("labels.status")), 1),
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_98, _toDisplayString(_ctx.trans("labels.time_spent_deal")), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_99, _toDisplayString(_ctx.trans("labels.payout_sum")), 1),
                        _createElementVNode("th", _hoisted_100, [
                          (_ctx.currentStore?.isActive && _ctx.store.getters.isMerchant)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.showCreateInvoiceForm && _ctx.showCreateInvoiceForm(...args))),
                                class: "btn btn-sm btn-outline-primary text-capitalize-first"
                              }, _toDisplayString(_ctx.trans("button.create_invoice")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices.items, (invoice) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: invoice.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("span", null, [
                                _createElementVNode("span", {
                                  title: invoice.id
                                }, _toDisplayString(invoice.id.substring(0, 8)) + "...", 9, _hoisted_102),
                                _cache[37] || (_cache[37] = _createTextVNode()),
                                _createVNode(_component_copy_button, {
                                  value: invoice.id
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("small", _hoisted_103, _toDisplayString(invoice.internalId ?? 'n/a'), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${invoice.type}`)), 1),
                          _createElementVNode("td", null, _toDisplayString(invoice.paymentOption ? _ctx.helper.trans(`payment_options.${invoice.paymentOption}`) : 'n/a'), 1),
                          _createElementVNode("td", null, _toDisplayString(invoice.paymentMethod ? _ctx.helper.trans(`pay_methods.${invoice.paymentMethod}`) : 'n/a'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(invoice.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString(invoice.storeName), 1),
                          _createElementVNode("td", null, _toDisplayString(invoice.userId ?? 'n/a'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(invoice.sum)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.trans(`invoice_status.${invoice.status}`)), 1),
                              _createElementVNode("small", _hoisted_105, _toDisplayString(_ctx.dateHelper.format(invoice.updatedAt)), 1)
                            ])
                          ]),
                          (_ctx.isAdmin || _ctx.isOperator)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_106, _toDisplayString(invoice.timeSpentCreateDeal), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(invoice.payoutSum ? _ctx.numberFormatter.formatMoney(invoice.payoutSum) : 'n/a'), 1),
                          _createElementVNode("td", _hoisted_107, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.details = invoice),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa fa-list" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.trans("button.details")), 1)
                            ], 8, _hoisted_108)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.invoices.totalCount > _ctx.invoices.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[34] || (_cache[34] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[35] || (_cache[35] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.invoices.totalCount,
                        "per-page": _ctx.invoices.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}